import { Modal, Spin } from 'antd'
import React from 'react'
import { useGenerateInterleavedPdf } from '../hooks/useGenerateInterleavedPdf'

type ExtractedBoxData = {
  barcode: string
  boxData: {
    type: number
    sourceId: number
    workspaceId: number
    deliveryGroupId: number
    boxId: number
  }
  pageNumber: number
}

type InterleavedPdfTemplateProps = {
  extractedBoxes: Array<ExtractedBoxData>
  uploadedPdfBytes: ArrayBuffer
  onClose: () => void
}

export const InterleavedPdfTemplate: React.FC<InterleavedPdfTemplateProps> = ({
  extractedBoxes,
  uploadedPdfBytes,
  onClose
}) => {
  const { isProcessing } = useGenerateInterleavedPdf({
    extractedBoxes,
    uploadedPdfBytes,
    onComplete: onClose
  })

  if (!isProcessing) {
    return null
  }

  return <Modal
    open
    closable={false}
    footer={null}
    centered
    width={200}
  >
    <div className="text-center p-5">
      <Spin size="large" />
      <div className="mt-4">Procesando PDF...</div>
    </div>
  </Modal>
}
